<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="活码名称">
                <el-input v-model="formInline.qrName" placeholder="活码名称"></el-input>
            </el-form-item>
            <el-form-item label="活码状态">
                <el-select v-model="formInline.qrStatus" clearable placeholder="活码状态">
                    <el-option label="草稿" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="停用" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="findList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="QrcodeList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="qrName" label="名称"></el-table-column>
            <el-table-column prop="qrType" label="类型">
                <template slot-scope="scope">
                    <el-tag size="mini" type="success" v-if="scope.row.qrType==1">链接</el-tag>
                    <el-tag size="mini" type="danger" v-if="scope.row.qrType==2">微信</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="qrDesc" label="备注"></el-table-column>
            <el-table-column prop="qrImg" label="活码">
                <template slot-scope="scope">
                    <img :src="scope.row.qrImg" width="70" height="70"/>
                </template>
            </el-table-column>
            <el-table-column prop="qrFullLink" label="活码链接"></el-table-column>
            <el-table-column prop="subCount" label="子码数量"></el-table-column>
            <el-table-column prop="scanCount" label="累计扫码人数"></el-table-column>
            <el-table-column prop="qrStatus" label="状态">
                <template slot-scope="scope">
                    <span>{{scope.row.qrStatus == 1 ? '启用' : (scope.row.qrStatus == 0 ? '草稿' : '停用')}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEditQr(scope.row.id)">编辑</el-button>
                    <el-button v-if="scope.row.qrStatus==1" type="warning" size="mini" @click="handleOnOff(scope.row.id)">停用</el-button>
                    <el-button v-if="scope.row.qrStatus==0 || scope.row.qrStatus==2" type="warning" size="mini" @click="handleOnOff(scope.row.id)">启用</el-button>
                    <el-button type="danger" size="mini" @click="handleDel(scope.row.id)">删除</el-button>
                    <el-button type="primary" size="mini" @click="handleShowQrSubs(scope.row.id,scope.row.qrType)">子码管理</el-button>
                    <el-button type="primary" size="mini" @click="handleDownload(scope.row.qrImg)">下载</el-button>
                    <el-button type="primary" size="mini" @click="handleDownloadExcel(scope.row.id)">统计</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <!-- QR添加编辑 -->
        <el-dialog title="新增/修改" :visible.sync="formVisible" center>
            <el-form :model="formQR" label-width="120px">
                <el-form-item label="类型">
                    <el-select v-model="formQR.qrType" clearable  placeholder="类型">
                        <el-option label="链接" value="1"></el-option>
                        <el-option label="个人微信号" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input v-model="formQR.qrName" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="formQR.qrDesc" placeholder="备注"></el-input>
                </el-form-item>
                <!--<el-form-item v-if="formQR.qrType==2" label="紧急联系客服微信号">
                    <el-input v-model="formQR.qrEconomicWechat" placeholder="紧急联系客服微信号"></el-input>
                </el-form-item>
                <el-form-item v-if="formQR.qrType==2" label="紧急联系电话">
                    <el-input v-model="formQR.qrEconomicTel" placeholder="紧急联系电话"></el-input>
                </el-form-item>-->
                <el-form-item label="失败时的提示*">
                    <el-input v-model="formQR.qrFailTip" placeholder="失败时的提示"></el-input>
                </el-form-item>
                <el-form-item v-if="formQR.qrType==2" label="成功时的提示">
                    <el-input v-model="formQR.qrSuccTip" placeholder="成功时的提示"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveQR()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findQrList,getQr,addOrEditQr,delQr,onoff,downloadQR} from '@/api/api';
    export default {
        data() {
            return {
                QrcodeList: [],
                formVisible : false,
                loading: true,
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                    qrName: "",
                    qrStatus: ""
                },
                formQR:{
                    id : "",
                    qrName : "",
                    qrType : "",
                    qrDesc : "",
                    qrEconomicWechat : "",
                    qrEconomicTel : "",
                    qrSuccTip : "",
                    qrFailTip : ""
                }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.findList();
        },
        methods: {
            findList(){
                findQrList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.QrcodeList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleAdd(){
                this.formQR.id = "";
                this.formQR.qrName = "";
                this.formQR.qrType = "";
                this.formQR.qrDesc = "";
                this.formQR.qrEconomicWechat = "";
                this.formQR.qrEconomicTel = "";
                this.formQR.qrSuccTip = "";
                this.formQR.qrFailTip = "";
                this.formVisible = true;
            },
            handleEditQr(id){
                getQr({"qrId":id}).then((res) => {
                    if (res.data.status == 200) {
                        this.formQR.id = res.data.value.id;
                        this.formQR.qrName = res.data.value.qrName;
                        this.formQR.qrType = res.data.value.qrType + "";
                        this.formQR.qrDesc = res.data.value.qrDesc;
                        this.formQR.qrEconomicWechat = res.data.value.qrEconomicWechat;
                        this.formQR.qrEconomicTel = res.data.value.qrEconomicTel;
                        this.formQR.qrSuccTip = res.data.value.qrSuccTip;
                        this.formQR.qrFailTip = res.data.value.qrFailTip;
                        this.formVisible = true;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveQR(){
                if(this.formQR.qrType == 2 && this.formQR.qrFailTip == ""){
                    this.$notify({
                        title: '提示',
                        message: '失败内容为必填项',
                        type: 'danger'
                    });
                    return false;
                }
                addOrEditQr(this.formQR).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.formVisible = false;
                        this.findList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleOnOff(id){
                onoff({"qrId":id}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.findList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleDel(id){
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delQr({"qrId":id}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.findList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
            handleDownload(imgUrl){
                window.open(imgUrl);
            },
            handleDownloadExcel(id){
                window.open(`${downloadQR}?qrId=` + id)
            },
            handleShowQrSubs(id,qrType){
                this.$router.push({path:'/qrcode/:qrId',name: 'subqrcode',query:{qrId:id,qrType:qrType}});
                // this.$router.push({path:'/userSystem/detail/:tab/:id',name: 'userSystemContent',params:{id:row,tab:'info'}})
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.findList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.findList();
            }
        }
    }
</script>
<style>
    .el-transfer{
        margin-left: 20%;
        height: 600px;
    }
    .el-transfer-panel{
        width:30%;
        height: 600px;
    }
    .el-transfer-panel__list.is-filterable{
        height: 584px;
    }
</style>


// WEBPACK FOOTER //
// src/views/qrcode/qrcode.vue